export default {
    data() {
        return {
        }
    },
    computed: {
        company() {
            return this.$route.params.company;
        },
        domain() {
            return this.$route.params.domain;
        },
        visitor() {
            return this.$route.params.visitor;
        },
        product(){
            return this.$route.params.product;
        },
        campaign() {
            return this.$route.params.campaign;
        },
        form() {
            return this.$route.params.form;
        },
        nstemplate() {
            return this.$route.params.nstemplate;
        },
        variant() {
            return this.$route.params.variant;
        },
        hasCompany (){
            return this.company != null;
        },
        breadcrumbs() {
            var b = [{ text: 'My companies', to: '/companies', icon: '$home', iconOnly: true, exact: true }];
            
            if(this.company) {
                var cn = this.$store.state.companies.item ? this.$store.state.companies.item.name : this.company;
                b.push({ text: cn, to: `/companies/${this.company}`, icon: '$company', exact: true })
            }
            if(this.domain) {
                var dn = this.$store.state.domains.item ? this.$store.state.domains.item.name : this.domain;
                b.push({ text: dn, to: `/companies/${this.company}/domains/${this.domain}`, icon: '$domain', exact: true })
            }
            
            if(this.campaign) {
                //b.push({text: 'Visitors', to: `/companies/${this.company}/domains/${this.domain}/stats/visitors`, exact: true })
                b.push({ text: `${this.$store.state.campaigns.item?.name ?? this.campaign}`, to: `/companies/${this.company}/domains/${this.domain}/campaigns/${this.campaign}`, icon: '$campaign', exact: false })
            }
            
            if(this.visitor) {
                //b.push({text: 'Visitors', to: `/companies/${this.company}/domains/${this.domain}/stats/visitors`, exact: true })
                b.push({ text: `Visitor ${this.visitor}`, to: `/companies/${this.company}/domains/${this.domain}/stats/visitors/${this.visitor}`, icon: '$visitor', exact: true })
            }
            b[b.length - 1].exact = false;
            return b;
        },
        baseurl() {
            var url = '';
            if(this.company) {
                url += '/companies/' + this.company;
            }
            if(this.domain) {
                url += '/domains/' + this.domain;
            }
            if(this.campaign) {
                url += '/campaigns/' + this.campaign;
            }
            //console.debug(url);
            return url;
        }
    },
    methods: {
        buildUrl(subpath) {
            //console.debug(`${this.baseurl}/${subpath}`);
            /*
            var url = '';
            if(this.company) {
                url += '/companies/' + this.company;
            }
            if(this.domain) {
                url += '/domains/' + this.domain;
            }
            */
            //console.debug(`${url}/${subpath}`);
            return `${this.baseurl}/${subpath}`;
        },
    },
    created() {
    }
}